import { createContext, type ReactNode, useContext, useState } from "react";
import { SignInModal } from "#/components/auth/SignInModal";

interface SignInModalContextValue {
	open: () => void;
	close: () => void;
}

const SignInModalContext = createContext<SignInModalContextValue>({
	open: () => {},
	close: () => {},
});

export function SignInModalProvider({ children }: { children: ReactNode }) {
	const [isOpen, setIsOpen] = useState(false);
	return (
		<SignInModalContext.Provider
			value={{ open: () => setIsOpen(true), close: () => setIsOpen(false) }}
		>
			{children}
			<SignInModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
		</SignInModalContext.Provider>
	);
}

export function useSignInModal() {
	return useContext(SignInModalContext);
}
